<template>
    <div class="page-wrap">
        <swiper autoplay @swiper="onSwiper">
            <swiper-slide v-for="item in PublicityPicture" :key="item">
                <div class="swiper-img-wrap">
                    <img :src="item" alt="" />
                </div>
            </swiper-slide>
            <!-- <swiper-slide>
        <div class="img-wrap">sss</div>
      </swiper-slide>
      <swiper-slide>
        <div class="img-wrap">dddd</div>
      </swiper-slide> -->
        </swiper>
        <div v-show="show">
            <div class="detail-content">
                <router-link to="/detail">
                    <div class="section-title">{{ dataInfo.Name }}</div>
                </router-link>
                <div>
                    <div class="section-tags" v-html="getAges()"></div>
                    <div class="section-museum">{{ dataInfo.Owner }}</div>
                </div>
            </div>
            <div class="section-wrap">
                <section>
                    <h3>图文介绍</h3>
                    <div class="section-content">
                        <p>简介</p>
                        <div>
                            {{ dataInfo.IntroduceContent }}
                        </div>
                        <div
                            class="img-wrap"
                            v-for="item in IntroducePicture"
                            :key="item"
                        >
                            <img :src="item" alt="" />
                        </div>
                        <p>亮点</p>
                        <div>
                            <div>
                                {{ dataInfo.HighlightsContent }}
                            </div>
                            <div
                                class="img-wrap"
                                v-for="item in HighlightsPicture"
                                :key="item"
                            >
                                <img :src="item" alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                <!-- 日程安排 -->
                <section>
                    <h3>{{ type == "Course" ? "课程" : "日程" }}安排</h3>
                    <div>
                        <ul class="class-list">
                            <li
                                v-for="(item, index) in dataInfo.EventDayList"
                                :key="item"
                            >
                                <div class="day-info">{{ item }}</div>
                                <div class="content-detail">
                                    <p>
                                        {{ dataInfo.EventTopicList[index] }}
                                    </p>
                                    <p v-if="type != 'Course'" class="address">
                                        {{ dataInfo.EventLocalList[index] }}
                                    </p>
                                </div>
                            </li>
                            <!-- <li>
              <div class="day-info">第二天</div>
              <div class="content-detail">
                <p></p>
                <p class="address"></p>
              </div>
            </li>
            <li>
              <div class="day-info">第三天</div>
              <div class="content-detail">
                <p></p>
                <p class="address"></p>
              </div>
            </li>
            <li>
              <div class="day-info">第四天</div>
              <div class="content-detail">
                <p></p>
                <p class="address"></p>
              </div>
            </li> -->
                        </ul>
                    </div>
                </section>
                <div class="blank-line"></div>
                <!-- 具体内容 -->
                <section>
                    <div class="top-bar">
                        <p>具体内容</p>
                        <p
                            @click="moreFn('detail1')"
                            class="more"
                            :class="detail1 ? 'up' : ''"
                        ></p>
                    </div>
                    <div
                        id="detail1"
                        :class="detail1 ? '' : 'hide'"
                        class="section-content"
                        style="padding-top: 0"
                    >
                        <div class="specific-wrap">
                            <div class="observer-line"></div>
                            <ul
                                class="specific-info"
                                :class="fixedState ? 'fixed-wrap' : ''"
                            >
                                <li
                                    v-for="(
                                        item, index
                                    ) in dataInfo.EventDayList"
                                    :key="item"
                                    :class="
                                        detailInfoIndex == index ? 'active' : ''
                                    "
                                    @click="goAnchor('#day_' + index, index)"
                                >
                                    <span>{{ item }}</span>
                                </li>
                            </ul>
                        </div>
                        <div
                            class="day"
                            v-for="(item, index) in dataInfo.EventDayList"
                            :key="item"
                            :id="'day_' + index"
                        >
                            <p>
                                {{ item }} {{ dataInfo.EventTopicList[index] }}
                            </p>
                            <div>
                                地点：{{ dataInfo.EventLocalList[index] }}
                            </div>
                            <div>
                                课时：{{ dataInfo.EventClassHourList[index] }}
                            </div>
                            <p>知识点</p>
                            <div>
                                {{ dataInfo.EventKnowledgePointsList[index] }}
                            </div>
                            <p>具体说明</p>
                            <div>{{ dataInfo.EventDetailList[index] }}</div>
                        </div>
                    </div>
                </section>
                <!-- 详细说明 -->
                <section>
                    <div class="top-bar">
                        <p>详细说明</p>
                        <p
                            @click="moreFn('detail2')"
                            class="more"
                            :class="detail2 ? 'up' : ''"
                        ></p>
                    </div>
                    <div
                        id="detail2"
                        :class="detail2 ? '' : 'hide'"
                        class="section-content"
                    >
                        <div>{{ dataInfo.DetailContent }}</div>
                        <div
                            class="img-wrap"
                            v-for="item in DetailPicture"
                            :key="item"
                        >
                            <img :src="item" alt="" />
                        </div>
                    </div>
                </section>
                <!-- 服务与安全 -->
                <section>
                    <div class="top-bar">
                        <p>服务与安全</p>
                        <p
                            @click="moreFn('detail3')"
                            class="more"
                            :class="detail3 ? 'up' : ''"
                        ></p>
                    </div>
                    <div
                        id="detail3"
                        :class="detail3 ? '' : 'hide'"
                        class="section-content"
                    >
                        <div>
                            {{ dataInfo.ServiceSafeContent }}
                        </div>
                        <div
                            class="img-wrap"
                            v-for="item in ServiceSafePicture"
                            :key="item"
                        >
                            <img :src="item" alt="" />
                        </div>
                    </div>
                </section>
                <!-- 报名须知 -->
                <section>
                    <div class="top-bar">
                        <p>报名须知</p>
                        <p
                            @click="moreFn('detail4')"
                            class="more"
                            :class="detail4 ? 'up' : ''"
                        ></p>
                    </div>
                    <div
                        id="detail4"
                        :class="detail4 ? '' : 'hide'"
                        class="section-content"
                    >
                        <div>{{ dataInfo.SignContent }}</div>
                        <div
                            class="img-wrap"
                            v-for="item in SignPicture"
                            :key="item"
                        >
                            <img :src="item" alt="" />
                        </div>
                    </div>
                </section>
                <!-- 其他路线 -->
                <section class="other-wrap" v-show="otherItem">
                    <h3>其他线路</h3>
                    <div class="other-content-wrap">
                        <ul>
                            <li
                                v-for="(item, index) in otherItems"
                                :key="item._id"
                            >
                                <router-link
                                    :to="
                                        '/detail?type=' +
                                        type +
                                        '&id=' +
                                        item._id
                                    "
                                >
                                    <div class="img-wrap">
                                        <img
                                            :src="
                                                otherItemsImgs[index]
                                                    .tempFileURL
                                            "
                                            alt=""
                                        />
                                    </div>
                                    <div class="other-title">
                                        {{ item.Name }}
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
            <!-- <div class="share-btn">分享</div> -->
        </div>
    </div>
</template>
<script>
// Import Swiper Vue.js components
import { getImgToCloud } from "../util/util";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { getImgsToCloud } from "../util/util";
// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";

import ShareImpl from "../util/wxShare.js";

// install Swiper modules
SwiperCore.use([Autoplay, Pagination]);
export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            show: false,
            type: "",
            detailInfoIndex: 0,
            dataInfo: {},
            fixedState: false,
            detail1: false,
            detail2: false,
            detail3: false,
            detail4: false,
            //海报图片
            PosterPicture: [],
            // 封面图片
            PublicityPicture: [],
            //亮点图片
            HighlightsPicture: [],
            // 服务与安全
            ServiceSafePicture: [],
            // 详细说明
            DetailPicture: [],
            // 报名须知图片
            SignPicture: [],
            // 简介图片
            IntroducePicture: [],
            otherItem: false,
            otherItems: [],
            otherItemsImgs: [],
        };
    },
    created() {
        const type = this.$route.query.type;
        this.type = type;
        const id = this.$route.query.id;
        if (type == "Course") {
            // 课程
            this.getAllCourse({ _id: id }).then((res) => {
                // console.log(res);
                this.dataInfo = res.data[0];
                this.getPictures();
                //this.inObserverDay();
                this.getOther();
            });
        } else {
            // 路线
            this.getAllRoads({ _id: id }).then((res) => {
                // console.log(res);
                this.dataInfo = res.data[0];
                this.getPictures();
                //this.inObserverDay();
                this.getOther();
            });
        }
        setTimeout(() => {
            this.show = true;
            this.wxShare();
        }, 1000);
    },
    mounted() {
        let olTop = 0;
        window.onscroll = () => {
            if (!this.detail1) return false;
            if (olTop == 0) {
                olTop = document.querySelector(".observer-line").offsetTop;
            }
            const sTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (sTop > olTop) {
                this.fixedState = true;
            } else {
                this.fixedState = false;
            }
        };
        window.addEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        wxShare() {
            let url = window.location.href
            ShareImpl({
                shareTitle: this.dataInfo.Name,
                shareDesc: this.dataInfo.Owner,
                shareUrl: url,
                shareImg: this.PublicityPicture[0],
            });
           // console.log(this.dataInfo.Name,this.dataInfo.Owner,this.PublicityPicture[0])
        },
        moreFn(id) {
            this[id] = !this[id];
        },
        handleScroll() {
            let distance = document.documentElement.scrollTop;
            let isInd = document.getElementsByClassName("day");

            for (var i = 0; i < isInd.length; i++) {
                if (
                    distance >=
                    document.getElementById("day_" + i).offsetTop - 45
                ) {
                    this.detailInfoIndex = i;
                }
            }
        },
        goAnchor(selector, ind) {
            this.detailInfoIndex = ind;
            document.querySelector(selector).scrollIntoView({
                behavior: "smooth",
            });
            console.log(this.detailInfoIndex);
            // /**
            //  * @description 锚链接滚动过渡
            //  * @param {String} selector   元素ID or 定位点
            //  */
            // // 移动距离
            // let top = 0;
            // // 当前滚动条位置
            // const scrollTop =
            //   document.documentElement.scrollTop ||
            //   window.pageYOffset ||
            //   document.body.scrollTop;
            // // 若为指定距离
            // if (typeof selector === "number") {
            //   top = selector - scrollTop;
            // } else {
            //   const anchor = document.querySelector(selector) || {
            //     offsetTop: 0,
            //   };
            //   top = anchor.offsetTop - scrollTop - 60;
            // }
            // window.scrollBy({ top, behavior: "smooth" });
        },
        // 观察天数
        inObserverDay() {
            var intersectionObserver = new IntersectionObserver(
                (entries) => {
                    // 如果不可见
                    if (entries[0].boundingClientRect.y > 0) {
                        // 取消悬浮
                        this.detailInfoIndex = entries[0].target.id.split(
                            "_"
                        )[1];
                    } else {
                        if (
                            entries[0].target.id.split("_")[1] ==
                            this.dataInfo.EventDayList.length - 1
                        ) {
                            this.fixedState = entries[0].isIntersecting;
                        }
                    }
                },
                {
                    threshold: 0.25,
                }
            );
            this.$nextTick(() => {
                this.dataInfo.EventDayList.forEach((item, index) => {
                    intersectionObserver.observe(
                        document.querySelector("#day_" + index)
                    );
                });
            });
        },
        getAges() {
            if (this.dataInfo.Age == undefined) return;
            let str = `<span class="tag">${
                this.type == "Roads" ? "线路" : "课程"
            }</span><span class="tag">${this.dataInfo.Class}</span>`;
            this.dataInfo.Age.split(",").map((age) => {
                str += `<span class="tag">${age}</span>`;
            });
            return str;
        },
        // 获取所有路线
        getAllRoads(params = {}) {
            const db = this.$TCB_App.database();
            const AllRoads = db.collection("DataBase_All_Roads");
            return AllRoads.where(params).get();
        },
        // 获取所有课程
        getAllCourse(params = {}) {
            const db = this.$TCB_App.database();
            const AllCourse = db.collection("DataBase_All_Course");
            return AllCourse.where(params).get();
        },
        getPictures() {
            //海报图片数量
            this.getPicture("PosterPicture");
            // 封面图片数量
            this.getPicture("PublicityPicture");
            //简介图片数量
            this.getPicture("HighlightsPicture");
            // 服务与安全
            this.getPicture("ServiceSafePicture");
            // 详细说明
            this.getPicture("DetailPicture");
            // 报名须知图片
            this.getPicture("SignPicture");
            // 简介图片
            this.getPicture("IntroducePicture");
        },
        //获取图片
        getPicture(filed) {
            getImgsToCloud({
                id: this.dataInfo._id,
                count: this.dataInfo[filed + "Count"],
                filed: filed,
                type: this.type,
            }).then((res) => {
                this[filed] = res.fileList.map((item) => {
                    if (item.code == "SUCCESS") {
                        return item.tempFileURL;
                    }
                });
            });
        },

        onSwiper(swiper) {
            console.log(swiper);
        },
        onSlideChange() {
            console.log("slide change");
        },
        // 获取其他路线
        getOther() {
            if (this.type == "Course") {
                // 课程
                this.getAllCourse({ Owner: this.dataInfo.Owner }).then(
                    (res) => {
                        const arr = res.data.filter((item) => {
                            return item._id != this.$route.query.id;
                        });
                        this.getImgs(arr, "Course");
                    }
                );
            } else {
                // 路线
                this.getAllRoads({ Owner: this.dataInfo.Owner }).then((res) => {
                    const arr = res.data.filter((item) => {
                        return item._id != this.$route.query.id;
                    });
                    this.getImgs(arr, "Roads");
                });
            }
        },
        getImgs(arr, type) {
            const ids = arr.map((item) => {
                return item._id;
            });
            if (ids.length > 0) {
                getImgToCloud({
                    name: type,
                    ids: ids,
                }).then((data) => {
                    this.otherItemsImgs = data.fileList;
                    this.otherItems = arr;
                    this.otherItem = true;
                });
            }
        },
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll, true);
    },
    onUnmounted() {
        window.removeEventListener("scroll", this.handleScroll, true);
    },
};
</script>

<style scoped lang="scss">
.hide {
    display: none;
}
.page-wrap {
    width: 100%;
    overflow: hidden;
    background: #faf9f9;
    .blank-line {
        height: 5.333vw;
        background: #faf9f9;
        margin: 0 -4vw;
    }
    ul {
        padding: 0;
        margin: 0;
        li {
            list-style-type: none;
        }
    }
}
.swiper-wrapper {
    height: 66.667vw;
}
.swiper-img-wrap {
    width: 100%;
    height: 66.667vw;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        max-height: 100%;
        max-width: 100%;
    }
}
.detail-content {
    padding: 5.333vw 4vw;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 0.133vw 0.4vw 0 #eeeeee;
    a {
        display: inline-block;
        text-decoration: none;
    }
    .section-title {
        font-size: 4.533vw;
        color: #111111;
        font-weight: bold;
    }

    .section-museum {
        font-size: 3.467vw;
        color: #7288a6;
        margin-top: 2.667vw;
    }
}

section {
    background: #ffffff;
    box-shadow: 0 0.133vw 0.4vw 0 #eeeeee;
    padding: 0 4vw;
    h3 {
        font-size: 4.533vw;
        color: #111111;
        font-weight: bold;
        padding: 5.333vw 0 4vw 0;
        margin: 0;
        background: #faf9f9;
        margin: 0 -4vw;
        padding-left: 4vw;
    }
    p {
        margin: 0;
        padding: 0;
    }
    .top-bar {
        font-size: 4.533vw;
        color: #111111;
        font-weight: bold;
        height: 15.2vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 0.133vw #edf2f9;
        border-top: solid 0.133vw #edf2f9;
        margin: 0 -4vw;
        padding: 0 4vw;
        .more::before {
            content: "";
            display: inline-block;
            width: 3.2vw;
            height: 2.933vw;
            background: url("../assets/down.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        .more.up::before {
            content: "";
            display: inline-block;
            width: 3.2vw;
            height: 2.933vw;
            background: url("../assets/up.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }
    .section-content {
        font-size: 3.733vw;
        color: #7288a6;
        padding: 5.333vw 0;
        p {
            font-size: 4vw;
            color: #12263f;
            font-weight: bold;
            padding: 5.333vw 0 2.667vw 0;
        }
    }
}

.other-content-wrap {
    overflow-x: scroll;
    a {
        text-decoration: none;
        user-select: none;
    }

    ul {
        padding: 0;
        margin: 0;
        display: inline-flex;
        white-space: nowrap;
        li {
            display: inline-block;
            width: 37.067vw;
            margin-right: 4vw;
            padding-top: 4vw;
        }
    }
    .img-wrap {
        width: 37.067vw;
        height: 25.333vw;
        display: flex;
        justify-content: center;
        align-content: center;
        background: #ccc;
        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .other-title {
        margin: 2.667vw 0;
        font-size: 3.733vw;
        height: 8.267vw;
        color: #12263f;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }
}
.share-btn {
    width: 91.333vw;
    height: 12vw;
    border: 0.267vw solid #71a209;
    border-radius: 1.333vw;
    border-radius: 1.333vw;
    margin: 5.333vw auto;
    font-size: 4.533vw;
    color: #71a209;
    font-weight: bold;
    line-height: 12vw;
    text-align: center;
}
.class-list {
    padding-top: 5.333vw !important;
    li {
        border-left: solid 1px #71a209;
        position: relative;
        padding-left: 2.667vw;
        display: flex;
        padding-bottom: 5.333vw;
        &::before {
            content: "";
            width: 4vw;
            height: 4vw;
            background: #ffffff;
            box-sizing: border-box;
            border-radius: 2vw;
            display: inline-block;
            border: 0.667vw solid #71a209;
            position: absolute;
            left: -2.133vw;
            top: 0;
        }
        .day-info {
            font-size: 3.733vw;
            color: #12263f;
            font-weight: bold;
            width: 14vw;
            flex-shrink: 0;
        }
        .content-detail {
            flex-shrink: 1;
            .address {
                font-size: 3.733vw;
                color: #7288a6;
                margin-top: 2.667vw;
            }
        }
    }
    li:last-child {
        border: none;
    }
}
.specific-info {
    white-space: nowrap;
    li {
        height: 12vw;
        display: inline-block;
        margin-right: 8vw;
        line-height: 12vw;
    }
    li:last-child {
        margin-right: 0;
    }
    li.active {
        font-size: 4vw;
        color: #000000;
        font-weight: bold;
        span {
            display: inline-block;
            position: relative;
            width: 100%;
            height: 100%;
            line-height: 12vw;
            &::after {
                content: "";
                position: absolute;
                width: 100%;
                height: 0.667vw;
                background: #71a209;
                bottom: 0;
                left: 0;
            }
        }
    }
}
.day {
    padding-top: 5.333vw;
}
.specific-wrap {
    overflow-x: scroll;
    overflow-y: hidden;
    height: 12vw;
}
.fixed-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 8vw);
    background: #fff;
    padding: 0 4vw !important;
    overflow-x: auto;
}
.observer-line {
    height: 0.133vw;
}
.section-content {
    .img-wrap {
        margin-top: 2.667vw;
        img {
            width: 100%;
        }
    }
}
</style>
<style lang="scss">
.section-tags {
    font-size: 3.2vw;
    color: #ffffff;
    margin-top: 2.667vw;
    span {
        padding: 0.8vw 1.333vw;
        display: inline-block;
        border-radius: 0.533vw;
        margin-right: 2.667vw;
    }
    span:nth-child(1) {
        background: #7cb6f3;
    }
    span:nth-child(2) {
        background: #e8b585;
    }
    span:nth-child(3) {
        background: #95a7ff;
    }
    span:nth-child(4) {
        background: #85e8a0;
    }
}
</style>